import React, { useEffect, useRef, useState } from "react";
import {
  ID_UPLOAD_LANGUAGE_WAIT_MESSAGE,
  getPreferredIdUploadLanguage,
  persistIdUploadLanguage,
} from "./languagePreference";

export default function GoogleTranslateWidget({ placement = "top" }) {
  const [language, setLanguage] = useState(getPreferredIdUploadLanguage);
  const [blocked, setBlocked] = useState(false);
  const blockedTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (blockedTimerRef.current) window.clearTimeout(blockedTimerRef.current);
    };
  }, []);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const changeLanguage = (nextLanguage) => {
    if (nextLanguage === language) return;

    if (document.querySelector('[data-language-switch-blocked="true"]')) {
      if (blockedTimerRef.current) window.clearTimeout(blockedTimerRef.current);
      setBlocked(true);
      blockedTimerRef.current = window.setTimeout(() => {
        setBlocked(false);
        blockedTimerRef.current = null;
      }, 3500);
      return;
    }

    const next = persistIdUploadLanguage(nextLanguage);
    setLanguage(next);
    window.location.reload();
  };

  return (
    <div className={`v0-language-switch v0-language-switch--${placement}`}>
      <div className="v0-language-options" role="group" aria-label="Language selector">
        {["it", "en"].map((option) => (
          <button
            key={option}
            type="button"
            className="v0-language-button"
            data-language={option}
            aria-pressed={language === option}
            onClick={() => changeLanguage(option)}
          >
            {option.toUpperCase()}
          </button>
        ))}
      </div>
      <span
        className={`v0-language-message ${blocked ? "is-visible" : ""}`}
        role={blocked ? "alert" : undefined}
        aria-live="polite"
      >
        {blocked ? ID_UPLOAD_LANGUAGE_WAIT_MESSAGE : ""}
      </span>
    </div>
  );
}
